import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const valid =
    sessionStorage.getItem("referredAs") == "User"
      ? Cookies.get("accessToken")
      : Cookies.get("pfaccessToken");
  return valid ? children : <Navigate to="/portal" />;
};

export default PrivateRoute;
